module.exports = __webpack_public_path__ + "static/media/AdviserIcon.fc1c00e4.svg";